module.exports = __webpack_public_path__ + "img/106.b62dad16.jpg";